import React from "react";

class DescriptionIcon extends React.Component {
  render() {
    return (
      <i className="anticon anticon-profile">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1.18em"
          height="1em"
          viewBox="0 0 15 18"
        >
          <path
            id="Forma_1"
            data-name="Forma 1"
            d="M74.713,299H64.746a1.287,1.287,0,0,0-1.287,1.284v0.82H62.287A1.287,1.287,0,0,0,61,302.387v13.329A1.287,1.287,0,0,0,62.287,317h9.968a1.287,1.287,0,0,0,1.287-1.284V314.9h1.171A1.287,1.287,0,0,0,76,313.613V300.284A1.287,1.287,0,0,0,74.713,299Zm-2.2,16.716a0.257,0.257,0,0,1-.257.257H62.287a0.257,0.257,0,0,1-.257-0.257V302.387a0.258,0.258,0,0,1,.257-0.257h1.172v11.483a1.287,1.287,0,0,0,1.287,1.283h7.767v0.82h0Zm2.458-2.1a0.258,0.258,0,0,1-.258.257H64.746a0.258,0.258,0,0,1-.257-0.257V300.284a0.257,0.257,0,0,1,.257-0.257h9.967a0.257,0.257,0,0,1,.258.257v13.329ZM73.5,302.189h-7.55a0.514,0.514,0,1,0,0,1.027H73.5A0.514,0.514,0,1,0,73.5,302.189Zm0,2.444h-7.55a0.514,0.514,0,1,0,0,1.027H73.5A0.514,0.514,0,1,0,73.5,304.633Zm0,2.444h-7.55a0.514,0.514,0,1,0,0,1.027H73.5A0.514,0.514,0,1,0,73.5,307.077Zm0,2.444h-7.55a0.514,0.514,0,1,0,0,1.027H73.5A0.514,0.514,0,1,0,73.5,309.521Z"
            transform="translate(-61 -299)"
            fill="currentColor"
          />
        </svg>
      </i>
    );
  }
}

export default DescriptionIcon;
